import { render, staticRenderFns } from "./BankAccountModal.vue?vue&type=template&id=640878f5&scoped=true&"
import script from "./BankAccountModal.vue?vue&type=script&lang=js&"
export * from "./BankAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640878f5",
  null
  
)

export default component.exports